/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useClient from "./useInspectionClient";
import { trackPromise } from "react-promise-tracker";

export const useStateData = <T,>(
  endpoint: string
): [T | undefined, () => Promise<void>] => {
  const client = useClient();
  const [data, setData] = useState<T>();

  const getData = async () => {
    try {
      const response = await client.api(endpoint).get();
      setData(response.data as T);
    } catch (error: any) {
      toast.error(error);
    }
  };

  useEffect(() => {
    if (!data) trackPromise(getData());
  }, []);

  return [data, getData];
};

export default useStateData;
